import _extends from "@babel/runtime/helpers/extends";
import * as React from "react";

function Bed(props) {
  return React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20"
  }, props), React.createElement("path", {
    fillRule: "evenodd",
    d: "M2.288 4.375c0-.69.56-1.25 1.25-1.25h12.924c.69 0 1.25.56 1.25 1.25v3.492a4.074 4.074 0 00-.349-.139A2 2 0 0015.5 5h-3a2 2 0 00-1.937 2.5h-.626A2.004 2.004 0 008 5H4.5a2 2 0 00-1.863 2.728 4.074 4.074 0 00-.349.139V4.375zm-1.5 4.72v-4.72a2.75 2.75 0 012.75-2.75h12.924a2.75 2.75 0 012.75 2.75v4.72c.338.492.538 1.077.538 1.724v.857a.746.746 0 01-.114.397c.225.234.364.552.364.903v2.295a1.3 1.3 0 01-.941 1.25c.433.553.691 1.25.691 2.008h-1.5c0-.974-.789-1.762-1.762-1.762H3.512c-.973 0-1.762.788-1.762 1.762H.25c0-.758.258-1.455.691-2.008A1.3 1.3 0 010 15.27v-2.295c0-.35.139-.669.364-.903a.747.747 0 01-.114-.397v-.857c0-.647.2-1.232.538-1.724zM4.5 6.5H8a.5.5 0 01.03 1H4.47a.5.5 0 01.03-1zm0 2.5h-.499c-1.357 0-2.25.919-2.25 1.82v.856h16.5v-.857c0-.9-.895-1.82-2.25-1.82h-.442L15.5 9h-11zm7.97-1.5h3.06a.5.5 0 00-.03-1h-3a.5.5 0 00-.03 1zM1.5 15.07v-1.894h17v1.895h-17z",
    clipRule: "evenodd"
  }));
}

export { Bed };
//# sourceMappingURL=Bed.js.map